
export const POSITIVE_RESPONSE = 'yes';
export const REQUEST_CALLBACK_RESPONSE = ['request', 'callback'];

const fetchRcbActionable = () => {
  const url = new URL(window.location.href);
  const pagePath = url.pathname;

  if (pagePath.includes('event/')) {
    const RcbContainer = document.getElementById('request-callback-container');
    const RcbParentDiv = document.querySelector(
      '.request-callback-event-widget',
    );

    if (RcbContainer && !RcbParentDiv) {
      const RcbEventParentDiv = document.createElement('div');
      RcbEventParentDiv.classList.add('request-callback-event-widget');

      RcbContainer.parentNode.insertBefore(RcbEventParentDiv, RcbContainer);

      RcbEventParentDiv.appendChild(RcbContainer);

      // eslint-disable-next-line no-unused-expressions
      RcbContainer.offsetHeight;
    }
    return 'request-callback-strip-action';
  }

  return null;
};

const fetchLastSystemResponse = (chats) => {
  const lastSystemChat = Object.values(chats)[
    Object.keys(chats).length - 1];
  return lastSystemChat?.response;
};

const containsRcbToken = (str) => REQUEST_CALLBACK_RESPONSE.every(
  word => str.includes(word),
);

export const isResponseValidForRcb = (prompt, chats = []) => {
  const response = fetchLastSystemResponse(chats);
  if (!prompt || !response) return false;
  return (prompt.toLowerCase().includes(POSITIVE_RESPONSE)
    && containsRcbToken(response.toLowerCase()));
};

export function requestCallback() {
  const rcbActionable = fetchRcbActionable();

  if (!rcbActionable) return;
  document.getElementById(rcbActionable).click();
}
